import {
    ACTION_ADD_NOTIFICATION,
    ACTION_DELETE_NOTIFICATION,
    DEFAULT_NOTIFICATION,
    type NotificationActionTypes,
    type NotificationMessage,
} from '../types/notification';

export function addNotification(notification: NotificationMessage = DEFAULT_NOTIFICATION): NotificationActionTypes {
    return {
        type: ACTION_ADD_NOTIFICATION,
        notification,
    };
}

export function deleteNotification(notification: NotificationMessage): NotificationActionTypes {
    return {
        type: ACTION_DELETE_NOTIFICATION,
        notification,
    };
}
